import {useLocalizedLabels} from "widget-shared-components-library";
import TabsAndSortingLabels from "../../ui/TabsAndSorting/TabsAndSortingLabels";
import mapping from "../../../config/mapping";


const useTabAndSorting = (devicesItems, rateplansItems, articlesItems, supportItems, setCurrentPage,
                          search, updateURL, setSelectedProductsSorting, setSelectedProductsPerPage, selectedProductsSorting, selectedProductsPerPage, setFiltersReady, onTabSelection) => {

    const labels = useLocalizedLabels(TabsAndSortingLabels);
    // Tabs
    const tabs = mapping.getTabs(labels, devicesItems, rateplansItems, articlesItems, supportItems);

    // Product per page dropdown
    const productsPerPage = mapping.getProductsPerPage(labels);

    // Handles dropdown option change by setting the selected option
    const handleProductsPerPageChange = (selectedOption) => {
        setSelectedProductsPerPage(selectedOption);
        setCurrentPage(1);
        updateURL("size", selectedOption?.value);
    };

    // Handles dropdown option change by setting the selected option
    const handleSortingOptionChange = (selectedOptionValue, selectedOptionKey) => {
        setSelectedProductsSorting(selectedOptionKey);
        setCurrentPage(1);
        updateURL("sort", selectedOptionKey);
    };

    const changeTab = (id, selectedProductsPerPage, selectedProductsSorting, currentPage) => {
        setFiltersReady(false);
        onTabSelection(id, selectedProductsPerPage, selectedProductsSorting, currentPage);
    }

    return {
        tabs,
        productsPerPage,
        handleProductsPerPageChange,
        handleSortingOptionChange,
        selectedProductsPerPage,
        selectedProductsSorting,
        labels,
        changeTab
    };

}
export default useTabAndSorting;